export default __webpack_public_path__ + "static/media/wheat-icon-2.a0295265.png";